import {FC} from 'react';
import {observer} from 'mobx-react';
import cx from 'classnames';
import {Button, Popup} from 'semantic-ui-react';

import {speedFromString} from '../utils';
import {SpeedType} from '../types';

import './Port.less';

type PortProps = {
  speedString: string | null;
  amount: number;
  onClick?: (speed: SpeedType, speedString?: string) => void | null;
  selected?: boolean;
  tooltip?: string;
  disabled?: boolean;
}

const Port: FC<PortProps> = ({speedString, amount, onClick, selected, tooltip, disabled}) => {
  const speed = speedFromString(speedString);

  const interactiveProps = (onClick && speedString) ?
    {
      onClick: () => onClick(speed, speedString),
      'aria-label': `Select ${speedString}`,
      disabled
    } : {};

  const empty = !speedString;

  const classNames = cx(
    're-port',
    `port-${speedString || 'na'}`,
    {
      interactive: !!onClick,
      empty,
      selected,
      disabled
    }
  );

  const button = (
    <Button
      key={speedString}
      className={classNames}
      {...interactiveProps}
    >
      {empty ? '\u00A0' : amount}
    </Button>
  );

  return tooltip ?
    <Popup className='re-ports-title' size='tiny' trigger={button}>{tooltip}</Popup> :
    button;
};

export default observer(Port);
